import React, { useEffect, useState } from 'react'
import DefaultLayout from 'src/layout/DefaultLayout'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CHeader,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react'
import Loading from 'src/components/Loading'
import axios from 'axios'
import { URL__API } from 'src/axios'
import { Link } from 'react-router-dom'
import CIcon from '@coreui/icons-react'
import { cilPen, cilPlus, cilX } from '@coreui/icons'
import Paginated from 'src/components/paginated/Paginated'
import * as toastr from 'toastr'
import 'toastr/build/toastr.css'

function Variables() {
  const [variables, setVariables] = useState([])
  const [visible, setVisible] = useState(false)
  const [variableId, setVariableId] = useState('')

  useEffect(() => {
    fetchVariables()
  }, [])
  const fetchVariables = async () => {
    const res = await axios.get(`${URL__API}/variables`, {
      headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
    })
    console.log(res.data)

    setVariables(res.data)
  }

  const handleAccept = async (id) => {
    setVisible(true)
    if (visible === true) {
      await axios.delete(`${URL__API}/variables/${id}`, {
        headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
      })
      setVisible(false)
      setVariableId('')
      fetchVariables()
      toastr.success('Ce variable est supprimé avec succès', {
        positionClass: 'toast-bottom-left',
      })
    }
  }

  return (
    <DefaultLayout>
      {variables.length === 0 ? (
        <Loading />
      ) : (
        <>
          <CModal alignment="center" visible={visible} onClose={() => setVisible(false)}>
            <CModalHeader>
              <CModalTitle>Suppression</CModalTitle>
            </CModalHeader>
            <CModalBody>Etes-vous sûr de supprimer ce variable ?</CModalBody>
            <CModalFooter>
              <CButton color="secondary" onClick={() => setVisible(false)}>
                Non
              </CButton>
              <CButton color="primary" onClick={() => handleAccept(variableId)}>
                Oui
              </CButton>
            </CModalFooter>
          </CModal>

          <Paginated items={variables}>
            {(paginatedVariables) => (
              <CCol xs>
                <CCard className="mb-4">
                  <CHeader className="mr-4 d-flex">
                    <CCardHeader>Variables</CCardHeader>
                    <Link
                      to="/addvariable"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        color: 'white',
                        background: '#2ACC96',
                        border: '#2ACC96',
                        textDecoration: 'none',
                        borderRadius: '20px',
                        margin: '20px',
                        paddingRight: '15px',
                        paddingLeft: '15px',
                        paddingBottom: '16px',
                        paddingTop: '16px',
                      }}
                    >
                      <CIcon icon={cilPlus} size="lg" style={{ marginRight: '16px' }}></CIcon>
                      Ajouter un variable
                    </Link>
                  </CHeader>
                  <CCardBody>
                    <br />
                    <CTable align="middle" className="mb-0 border" hover responsive>
                      <CTableHead color="light">
                        <CTableRow>
                          <CTableHeaderCell>Label</CTableHeaderCell>
                          <CTableHeaderCell>Valeur</CTableHeaderCell>
                          <CTableHeaderCell className="text-center">Actions</CTableHeaderCell>
                        </CTableRow>
                      </CTableHead>

                      <CTableBody>
                        {paginatedVariables &&
                          paginatedVariables.map((item, index) => (
                            <CTableRow v-for="item in tableItems" key={index}>
                              <CTableDataCell>{item.label}</CTableDataCell>
                              <CTableDataCell>{item.value}</CTableDataCell>

                              <CTableDataCell className="text-center">
                                <Link to={`/variable/${item.id}`}>
                                  <CIcon
                                    icon={cilPen}
                                    title="Modifie"
                                    style={{
                                      color: '#2ACC96',
                                      border: '2px solid #2ACC96',
                                      borderRadius: '100%',
                                      margin: '9px',
                                      cursor: 'pointer',
                                    }}
                                    size="xl"
                                  />
                                </Link>
                                <CIcon
                                  title="supprimer"
                                  icon={cilX}
                                  style={{
                                    cursor: 'pointer',
                                    color: 'red',
                                    border: '2px solid red',
                                    borderRadius: '100%',
                                    padding: '1px',
                                    margin: '9px',
                                  }}
                                  size="xl"
                                  onClick={() => {
                                    setVisible(true)
                                    setVariableId(item.id)
                                  }}
                                />
                              </CTableDataCell>
                            </CTableRow>
                          ))}
                      </CTableBody>
                    </CTable>
                  </CCardBody>
                </CCard>
              </CCol>
            )}
          </Paginated>
        </>
      )}
    </DefaultLayout>
  )
}

export default Variables
